import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import BookingForm from "@/components/BookingForm";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

export default function ServicePage({ type, title, subtitle, image, intro, packages, perks, path, seoTitle, seoDesc, cta = "Book Your Slot" }) {
  return (
    <>
      <SEO title={seoTitle} description={seoDesc} path={path} image={image} />
      <PageHero title={title} subtitle={subtitle} image={image} crumbs={[{ label: title }]} />

      <section className="container-px py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_1fr] lg:items-start">
          <div>
            <p className="overline">{type}</p>
            <h2 className="mt-2 text-3xl sm:text-4xl font-black tracking-tight">{intro.heading}</h2>
            <p className="mt-4 text-muted-foreground leading-relaxed">{intro.text}</p>

            {perks && (
              <Stagger className="mt-8 grid gap-4 sm:grid-cols-2">
                {perks.map((p) => (
                  <StaggerItem key={p}>
                    <div className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 text-sm font-semibold">
                      <CheckCircle size={20} weight="fill" className="text-primary shrink-0" /> {p}
                    </div>
                  </StaggerItem>
                ))}
              </Stagger>
            )}

            {packages && (
              <div className="mt-10 space-y-4">
                <h3 className="text-xl font-black tracking-tight">{packages.heading}</h3>
                {packages.items.map((pk) => (
                  <Reveal key={pk.name}>
                    <div className="flex items-center justify-between gap-4 rounded-3xl border border-border bg-card p-5">
                      <div>
                        <p className="font-bold">{pk.name}</p>
                        <p className="text-sm text-muted-foreground">{pk.desc}</p>
                      </div>
                      <span className="shrink-0 text-xl font-black text-primary">{pk.price}</span>
                    </div>
                  </Reveal>
                ))}
              </div>
            )}
          </div>

          <div className="lg:sticky lg:top-24">
            <BookingForm type={type.toLowerCase()} accent={cta} />
          </div>
        </div>
      </section>

      <section className="bg-card border-t border-border py-12">
        <div className="container-px text-center">
          <h3 className="text-2xl font-black tracking-tight">Prefer to talk it through?</h3>
          <p className="mt-2 text-muted-foreground">Call our workshop team or pop into our Kent showroom.</p>
          <Link to="/contact" className="btn-primary mt-5">Contact the workshop <ArrowRight size={18} /></Link>
        </div>
      </section>
    </>
  );
}
